import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IMaskModule } from 'angular-imask';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { ToastModule } from 'primeng/toast';
import { GrupoEstoqueFormComponent } from './grupo-estoque-form/grupo-estoque-form.component';
import { GrupoEstoqueListComponent } from './grupo-estoque-list/grupo-estoque-list.component';
import { GrupoEstoqueRoutingModule } from './grupo-estoque-routing.module';
import { GrupoEstoqueViewComponent } from './grupo-estoque-view/grupo-estoque-view.component';
import { SharedModule } from 'eddydata-lib';
import { FieldsetModule } from 'primeng/fieldset';
import { CheckboxModule } from 'primeng/checkbox';

@NgModule({
  declarations: [GrupoEstoqueListComponent, GrupoEstoqueFormComponent, GrupoEstoqueViewComponent],
  imports: [
    CommonModule,
    GrupoEstoqueRoutingModule,
    SharedModule,
    FormsModule,
    AutoCompleteModule,
    CalendarModule,
    IMaskModule,
    ToastModule,
    FieldsetModule,
    CheckboxModule
  ]
})
export class GrupoEstoqueModule { }
